import { Loader2 } from "lucide-react";
import taskeerLogo from "@/assets/taskeerlogo.png";

export const PageLoading = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center gap-6">
      <div className="relative">
        <img 
          src={taskeerLogo} 
          alt="Taskeer" 
          className="h-16 w-auto animate-pulse"
        />
      </div>
      <div className="flex items-center gap-2">
        <Loader2 className="h-5 w-5 animate-spin text-primary" />
        <span className="text-sm text-muted-foreground animate-pulse">Carregando...</span>
      </div>
    </div>
  );
};
